import React, { useMemo } from 'react';
import { CardBrands } from 'types';
import { ISelectOption } from 'components/Select/types';
import { cardBrands } from 'appConstants';
import { Rule } from 'antd/lib/form';
import { useTranslation } from 'react-i18next';
import { FormSelectNew } from 'components/Select/FormSelectNew';

interface IProps {
	name: string;
	mccFieldName?: string;
	testId: string;
	selectedBrand: Nullable<CardBrands>;
	reservedBrands: Nullable<CardBrands>[];
	onChange: (value: CardBrands) => void;
}

export const CardBrandSelect: React.FC<IProps> = React.memo(
	({ name, mccFieldName, testId, selectedBrand, reservedBrands, onChange }) => {
		const { t } = useTranslation('error');

		const validationRules = useMemo<Rule[]>(
			() =>
				mccFieldName
					? [
							({ getFieldValue }) => ({
								validator: (_, value) => {
									if (getFieldValue(mccFieldName) && !value) {
										return Promise.reject(new Error(t('selectCardBrand')));
									}
									return Promise.resolve();
								},
							}),
					  ]
					: [],
			[t, mccFieldName],
		);

		const options = useMemo<ISelectOption[]>(
			() =>
				cardBrands.map((el) => ({
					id: el.id,
					name: el.name,
					disabled: el.id !== selectedBrand && reservedBrands.includes(el.id),
				})),
			[selectedBrand, reservedBrands],
		);

		return (
			<FormSelectNew
				testId={testId}
				name={name}
				label="cardBrandLabel"
				options={options}
				withSearch={false}
				validationRules={validationRules}
				onChange={onChange}
			/>
		);
	},
);
